import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=3df1102c&scoped=true&"
import script from "./file-viewer.vue?vue&type=script&lang=js&"
export * from "./file-viewer.vue?vue&type=script&lang=js&"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=3df1102c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1102c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df1102c')) {
      api.createRecord('3df1102c', component.options)
    } else {
      api.reload('3df1102c', component.options)
    }
    module.hot.accept("./file-viewer.vue?vue&type=template&id=3df1102c&scoped=true&", function () {
      api.rerender('3df1102c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/files-viewer/file-viewer.vue"
export default component.exports